// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","headerWrap":"Header_headerWrap__SicAp"};